import React, { useEffect, useState } from "react";
import "../Table/Table.css";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Loading from "../Loading";
import DataTable from "../DataTable/DataTable";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { Box, Button, Typography, TextField, Modal,MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchRoles } from "../../api/roleApi";
import { useQuery } from "@tanstack/react-query";
import { getPermissionByPrefix } from "../../utils/permissions";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IconButton, InputAdornment } from "@mui/material";
import { useErrorToast } from "../../hooks/useErrorToast";

function Staff() {
    const showError = useErrorToast();

  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [loadingFull, setLoadingFull] = useState(false);
  const [contractLoading, setContractLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const { is_view, is_add, is_edit, is_delete } = getPermissionByPrefix("manage_user");
  
    const {
      data: roles = [],
      isLoading,
      isFetching,
      error,
    } = useQuery({
      queryKey: ["roles"],
      queryFn: fetchRoles,
      retry:false,
      onError: (error) => {
        if (error.response?.status === 401) {
          // toast.error("Session Expired! Please Login");
                showError("Session Expired! Please Login");

          localStorage.removeItem("tokenInv");
          localStorage.removeItem("roleInv");
          navigate("/");
        } else {
                showError(error.response?.data?.error || "Failed to update profile. Please try again.");
          // toast.error(error.response?.data?.error || "Failed to update profile. Please try again.");
        }
      },
    });

  useEffect(() => {
    handleUser();
  }, []);

  const handleUser = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(`${process.env.REACT_APP_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      // setContracts(response.data);
      setContracts(
  response.data.map((user) => ({
    ...user,
    role: user.role?.name || "N/A",
  }))
);

      setEditModal(false);
      setDeleteModal(false);
      setSelectedUser({});
      setAddModal(false);
    } catch (error) {
      console.log("Failed Fetching SOF", error.response.data.error);
      if (error.response.status === 401) {
        // toast.error("Session Expired! Please Login");
                        showError("Session Expired! Please Login");
        
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(error.response.data.error || "Failed to update profile. Please try again.");
        showError(error.response?.data?.error || "Failed to update profile. Please try again.");
      }
    } finally {
      setContractLoading(false);
      setLoadingFull(false);
    }
  };

  const handleAddUser = async () => {
    if (
      !selectedUser?.name ||
      !selectedUser?.email ||
      !selectedUser?.password ||
      !selectedUser?.role_id
    ) {
      toast.error("Please fill all fields");
      return;
    }
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user`,
        selectedUser,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleUser();
    } catch (error) {
      if (error.response.status === 401) {
        // toast.error("Session Expired! Please Login");
                        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(error.response.data.error || "Failed to update profile. Please try again.");
        showError(error.response?.data?.error || "Failed to update profile. Please try again.");
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const handleEditUser = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/user/${selectedUser.id}`,
        selectedUser,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleUser();
    } catch (error) {
      if (error.response.status === 401) {
        // toast.error("Session Expired! Please Login");
                        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(error.response.data.error || "Failed to update profile. Please try again.");
        showError(error.response?.data?.error || "Failed to update profile. Please try again.");
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const handleDeleteUser = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/user/${selectedUser.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleUser();
    } catch (error) {
      if (error.response.status === 401) {
        // toast.error("Session Expired! Please Login");
                        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(error.response.data.error || "Failed to update profile. Please try again.");
        showError(error.response?.data?.error || "Failed to update profile. Please try again.");
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const columns = [
    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "role", headerName: "Role", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
    {
      field: "actions",
      headerName: "",
      width: 250,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
            }}
          >
            {is_edit && (<Button
              variant="contained"
              onClick={() => {
                setSelectedUser(params.row);
                setEditModal(true);
              }}
              sx={{
                fontSize: "12px",
                marginLeft: "5px",
                display: "flex",
                marginTop: "7px",
                backgroundColor: "rgb(124, 46, 160)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <FaEdit color="#FFF" size={20} title="Edit" />
              </div>
            </Button>)}
            {is_delete && (<Button
              variant="contained"
              onClick={() => {
                setSelectedUser(params.row);
                setDeleteModal(true);
              }}
              sx={{
                fontSize: "12px",
                marginLeft: "5px",
                display: "flex",
                marginTop: "7px",
                backgroundColor: "rgb(124, 46, 160)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <FaTrash color="#FFF" size={20} title="Edit" />
              </div>
            </Button>)}
          </Box>
        );
      },
    },
  ];

        if (!is_view) {
  return <div>You do not have permission to view this page.</div>;
}

  return (
    <div style={profileStyle}>
      <Toaster position="top-right" reverseOrder={false} style={{ zIndex: "9999999" }}/>
      {loadingFull && <Loading />}
      <div className="table-header">
        <h2>User</h2>
                {is_add && (
<button className="upload-button" onClick={() => setAddModal(true)}>
          <FaPlus
            style={{
              marginRight: "5px",
            }}
          />
          Add User
        </button>)}
      </div>
      <div style={{ marginBottom: "30px" }}>
        <DataTable columns={columns} rows={contracts} />
      </div>

      {/* Add Modal; */}
      <Modal
        open={addModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setAddModal(false);
            setSelectedUser({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Add User
          </Typography>

          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            required
            name="name"
            value={selectedUser?.name}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            required
            name="email"
            value={selectedUser?.email}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            required
            name="password"
            type={showPassword ? "text" : "password"}
            value={selectedUser?.password}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
             InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </IconButton>
      </InputAdornment>
    ),
  }}
          />

          {/* <TextField
            fullWidth
            label="Role"
            variant="outlined"
            required
            name="role"
            value={selectedUser?.role}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          /> */}
<TextField
  select
  fullWidth
  label="Role"
  variant="outlined"
  required
  name="role_id"
  value={Number(selectedUser?.role_id) || ""}
  // value={selectedUser?.role_id || ""}
  onChange={(e) => {
    setSelectedUser((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }}
>
  {roles.map((role) => (
    <MenuItem key={role.id} value={role.id}>
      {role.name}
    </MenuItem>
  ))}
</TextField>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleAddUser();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setAddModal(false);
                setSelectedUser({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Edit Modal; */}
      <Modal
        open={editModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setEditModal(false);
            setSelectedUser({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Edit User
          </Typography>

          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            required
            name="name"
            value={selectedUser?.name}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <TextField
            fullWidth
            label="Contact"
            variant="outlined"
            required
            name="email"
            value={selectedUser?.email}
            onChange={(e) => {
              setSelectedUser((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleEditUser();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setEditModal(false);
                setSelectedUser({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Delete Modal  */}
      <Modal
        open={deleteModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setDeleteModal(false);
            setSelectedUser({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete User <b>{selectedUser?.name}</b>
            ?
          </Typography>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleDeleteUser();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setDeleteModal(false);
                setSelectedUser({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      <div id="scroll-to-bottom"></div>
    </div>
  );
}

const profileStyle = {
  // width: "90%",
  background: "#fff",
  borderRadius: "8px",
  marginInline: "16px",
  marginTop: "20px",
  padding: "20px",
};

export default Staff;
